import * as actionTypes from './../actions/pdfOutputAction';

const initialState = {
  images: {},
  error: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.ADD:
      const key = action.key;
      return {
        ...state,
        images: {
          ...state.images,
          [action.key]: action.data
        }
      }

    case actionTypes.CLEAR_IMAGES:
      return {
        ...state,
        images: {},
        error: false,
      };

    case actionTypes.SCREENSHOT_ERROR:
      return {
        ...state,
        error: true,
      };

    default:
      return state;
  }
};

export default reducer;
